import { t } from "@travily/i18n";
import { TileRadioGroup } from "@ui/components/TileRadioGroup/TileRadioGroup";
import { Wizard } from "@ui/components/Wizard";
import { useBreakpoint } from "@ui/hooks/use-breakpoint";
import type { ReactNode } from "react";

const COLOR = "green" as const;

export interface ProductPriceTypeStepViewProps {
  currentStage: number;
  totalStages: number;
  value: "free" | "paid";
  primaryPending: boolean;
  topBarActions: ReactNode;
  onBack?: () => void;
  onPrimary: () => void;
  onChange: (value: string) => void;
}

// First pricing stage: a clean free-or-paid fork with no price field. Choosing
// "Paid" routes on to the selling-country step (first time) or the price.
export const ProductPriceTypeStepView = ({
  currentStage,
  totalStages,
  value,
  primaryPending,
  topBarActions,
  onBack,
  onPrimary,
  onChange,
}: ProductPriceTypeStepViewProps) => {
  const isAboveMd = useBreakpoint("md");
  const isAboveLg = useBreakpoint("lg");
  const selectionGroupSize = isAboveLg ? "5xl" : isAboveMd ? "4xl" : "3xl";

  return (
    <Wizard color={COLOR} currentStage={currentStage} totalStages={totalStages} onBack={onBack}>
      {topBarActions}
      <Wizard.PrimaryButton onPress={onPrimary} isPending={primaryPending}>
        {t("common.actions.continue")}
      </Wizard.PrimaryButton>
      <Wizard.Stage
        heading={t("web.products.creator.steps.price_type.show.title")}
        helper={t("web.products.creator.steps.price_type.show.subtitle")}
      >
        <div className="w-full max-w-[600px]">
          <TileRadioGroup
            aria-label={t("web.products.creator.steps.price_type.show.title")}
            align="horizontal"
            color={COLOR}
            size={selectionGroupSize}
            value={value}
            onChange={onChange}
          >
            <TileRadioGroup.Item value="free">
              {t("web.products.creator.steps.price_type.show.free_label")}
            </TileRadioGroup.Item>
            <TileRadioGroup.Item value="paid">
              {t("web.products.creator.steps.price_type.show.paid_label")}
            </TileRadioGroup.Item>
          </TileRadioGroup>
        </div>
      </Wizard.Stage>
    </Wizard>
  );
};
